import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { actions, StepType } from '../../../../entities/rates';
import * as providerActs from '../../../../entities/providers';
import { getDeliversServices } from '../../../../entities/providers/selectors';

export function useAutoSelectService() {
  const ranOnceRef = useRef(false);

  const { query } = useRouter();
  const dispatch = useDispatch();

  const preferredService = (query?.via as string) ?? '';

  const services = useSelector(getDeliversServices);

  useEffect(() => {
    if (preferredService && !ranOnceRef.current) {
      dispatch(providerActs.bookService({ service: preferredService }));

      if (services?.length) {
        const found = services.some(({ type }) => type === preferredService);

        if (found) {
          dispatch(actions.setStep({ step: StepType.form }));

          ranOnceRef.current = true;
        } else {
          dispatch(providerActs.bookService({ service: '' }));

          ranOnceRef.current = true;
        }
      }
    }
  }, [preferredService, services]);
}
